import React, { HTMLAttributes, useRef, useState } from "react";
import { IconContext } from "react-icons";
import { MdArrowUpward } from "react-icons/md";
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { EffectCreative, Mousewheel, Pagination } from "swiper/modules";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import LandingAnimateSplash from "../LandingAnimateSplash";
import ChargerSpecSection from "../chargerSpecSection";
import HowToUseSction from "../howToUseSection";
import PriceSection from "../howToUseSection/priceSection";
import JoinAsgardSection from "../joinAsgardSection";
import PartnerSection from "../partnerSection";
import VideoTutorialSection from "../videoTutorialSection";
import WhereToChargeSection from "../whereToChargeSection";
import WhoIsSection from "../whoIsSection";

interface IContentBlock {}

type TContentBlockProps = IContentBlock & HTMLAttributes<HTMLDivElement>;

const ContentBlock: React.FC<TContentBlockProps> = (props) => {
  const { ...otherProps } = props;

  // Reference to Swiper instance
  const swiperRef = useRef<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  React.useEffect(() => {
    const disableHandler = () => {
      try {
        swiperRef.current?.mousewheel?.disable?.();
      } catch {
        /* ignore if not ready */
      }
    };
    const enableHandler = () => {
      try {
        swiperRef.current?.mousewheel?.enable?.();
      } catch {
        /* ignore if not ready */
      }
    };

    window.addEventListener("swiper-mousewheel-disable", disableHandler);
    window.addEventListener("swiper-mousewheel-enable", enableHandler);
    return () => {
      window.removeEventListener("swiper-mousewheel-disable", disableHandler);
      window.removeEventListener("swiper-mousewheel-enable", enableHandler);
    };
  }, []);

  const onScrollHandler = (index: number) => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(index); // Slide to index 2
    }
  };

  return (
    <div
      className="main-block flex flex-col gap-24 laptop:gap-40 bg-black h-[100dvh] max-w-[100vw]"
      {...otherProps}
    >
      <Swiper
        direction="vertical" // Enables vertical scrolling
        effect={"creative"}
        creativeEffect={{
          prev: {
            shadow: true,
            translate: [0, "-100%", 0],
          },
          next: {
            translate: [0, "100%", 0],
          },
        }}
        onSwiper={(swiper: SwiperClass) => (swiperRef.current = swiper)} // Store Swiper instance
        onSlideChange={(swiper: SwiperClass) =>
          setActiveIndex(swiper.activeIndex)
        }
        speed={1150}
        slidesPerView={1} // One section per view
        spaceBetween={80} // No space between sections
        mousewheel={true} // Enable mouse wheel scrolling
        modules={[Pagination, Mousewheel, EffectCreative]}
        pagination={activeIndex !== 0 ? { clickable: true } : false} // Add pagination dots
        className="h-screen w-full"
      >
        <SwiperSlide>
          <LandingAnimateSplash onScrollHandler={onScrollHandler} />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <WhereToChargeSection onScrollHandler={onScrollHandler} />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <HowToUseSction />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <VideoTutorialSection />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <PriceSection />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <JoinAsgardSection />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <ChargerSpecSection />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <WhoIsSection />
        </SwiperSlide>
        <SwiperSlide className="flex justify-center">
          <PartnerSection />
        </SwiperSlide>
      </Swiper>

      {activeIndex > 5 && (
        <div className="fixed bottom-5 right-5 z-30">
          <div onClick={() => onScrollHandler(1)}>
            <div className="group rounded-full transition-all duration-500 ease-in-out cursor-pointer">
              <IconContext.Provider
                value={{
                  className:
                    "fill-[#50BDEC] group-hover:fill-mainBlue transition-all duration-500 ease-in-out",
                }}
              >
                <MdArrowUpward size={30} />
              </IconContext.Provider>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentBlock;
